export enum AuthErrors {
  RefreshTokenError = 1,
  LostUserDetails = 2,
  PermissionsMissing = 3,
  ForceLogout = 4,
  FailedRedirect = 5,
  UserNotActive = 6
}
